import React, { useState } from 'react';
import {
	Grid,
	TextField,
	Box,
	makeStyles,
	FormControlLabel,
	Checkbox,
	Radio,
	RadioGroup,
	FormControl,
} from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import bus from '../assets/images/bus.png';
import { useDispatch, useSelector } from 'react-redux';
import DateRange from '../components/reusableComponents/DateRange';
import DateRangeNew from '../components/reusableComponents/DateRangeNew';
import BodyText from '../components/reusableComponents/BodyText';
import TitleText from '../components/reusableComponents/TitleText';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import { SearchReturnFormDispatch } from '../reducers/HomeReducer';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import DesktopDate from '../components/reusableComponents/DesktopDate';
import DesktopDateNew from '../components/reusableComponents/DesktopDateNew';
import DesktopDateBus from '../components/reusableComponents/DesktopDateBus';
import { fetchBusCityDispatch } from '../reducers/BusReducer';
const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiFormControl-root': {
			'& div': {
				'& div': {
					display: 'none',
				},
			},
		},
		'& .MuiInput-underline:before': {
			borderBottom: 'none',
		},
		'& .MuiInput-underline:after': {
			borderBottom: 'none',
		},
		'& input': {
			// fontSize: 24,
		},
	},
	radio: {
		'& .MuiRadio-root': {
			color: 'white',
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: '#f50057',
		},
		'& .MuiTypography-body1': {
			color: 'white',
			fontSize: 14,
		},
	},
}));
const SearchBus2 = () => {
	const [result, setResult] = useState([]);
	const [result2, setResult2] = useState([]);
	const classes = useStyles();
	const { city } = useSelector((state) => state.home);
	const { buscity } = useSelector((state) => state.bus);
	const handleRadio = (event) => {
		setValue(event.target.value);
	};
	const history = useHistory();
	const dispatch = useDispatch();
	const [data, setData] = useState(true);

	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [infant, setInfant] = useState(0);
	const [value, setValue] = useState('Economy');
	const [leaving, setLeaving] = useState('DEL');
	const [trip, setTrip] = useState('oneway');
	const [going, setGoing] = useState('CCU');
	const { origin, depart } = useSelector((state) => state.ui);
	let invoiceOptions = [];
	let demo = [];
	// city &&
	// 	city.data &&
	// 	city.data.length > 0 &&
	// 	city.data.forEach((invoice, index) => {
	// 		invoiceOptions.push({
	// 			code: invoice.iata_code,
	// 			city: invoice.city,
	// 			country: invoice.country_name,
	// 		});
	// 		if (index < 50) {
	// 			demo.push({
	// 				code: invoice.iata_code,
	// 				city: invoice.city,
	// 				country: invoice.country_name,
	// 			});
	// 		}
	// 	});
	const handleSubmit = (data) => {
		history.push('/buslist')
	};
	console.log(invoiceOptions);
	// const handleSearch = (event) => {
	// 	let value = event.target.value.toLowerCase();
	// 	console.log(value);
	// 	if (value.length >= 2) {
	// 		let results =
	// 			invoiceOptions &&
	// 			invoiceOptions.filter((data) => {
	// 				return Object.values(data).join('').toLowerCase().includes(value);
	// 			});
	// 		setResult(results);
	// 	} else {
	// 		setResult([]);
	// 	}
	// };
	// const handleSearch2 = (event) => {
	// 	let value = event.target.value.toLowerCase();
	// 	let results = [];
	// 	console.log(value);
	// 	if (value.length >= 2) {
	// 		results =
	// 			invoiceOptions &&
	// 			invoiceOptions.filter((data) => {
	// 				return Object.values(data).join('').toLowerCase().includes(value);
	// 			});
	// 		setResult2(results);
	// 	} else {
	// 		setResult2([]);
	// 	}
	// };
	console.log(leaving);
	console.log(going);
	const handleChange2 = (e) => {
		console.log(e.target.value);
		dispatch(setTrip(e.target.value));
	};
	const handleSearchOrigin = (event) => {
		let value = event.target.value.toLowerCase();
		// console.log(value);
		let cityData = {
		  keywords: value,
		  limits: 10,
		};
		dispatch(fetchBusCityDispatch(cityData));
	  };
	return (
		<>
			<Formik
				initialValues={{
					Origin: '',
					Destination: '',
				}}
				validate={(values) => {
					const errors = {};
				}}
				// onSubmit={handleSubmit}
				>
				{({ submitForm, isSubmitting, setFieldValue, values }) => (
					<>
						<Form style={{}}>
							
							<Grid
								container
								spacing={2}
								alignItems='center'
								style={{ marginTop: 10 }}>
								<Grid item xs={12} md={12} lg={3}>
								<Box
                          style={{
                            border: "1px solid #767b8e",
                            borderRadius: 5,
                            paddingLeft: 13,
                          }}
                        >
									<div className={classes.root} style={{ width: '100%' }}>
										<span style={{ color: 'black',fontSize:20 }}>From</span>
										<Autocomplete
											id='country-select-demo'
											sx={{
												// background: '#eee',
												// borderRadius: 2,
												padding: '8px',
											}}
											options={buscity && buscity.result.length > 0 ? buscity.result : []}
											autoHighlight
											getOptionLabel={(option) => option.city_name}
											renderOption={(props, option) => (
												<Box
													mr={'5px'}
													component='li'
													sx={{ '& > img': { mr: 2 } }}
													{...props}>
													<img loading='lazy' width='20' src={bus}  />
													<p style={{marginLeft:5}}>
													{option.city_name} ({option.city_id})
													</p>
												</Box>
											)}
											onChange={(event, value) => {
												setFieldValue('Origin', value.code);
												console.log(value.code);
												// setLeaving(value.code);
											}}
											renderInput={(params) => (
												<TextField
													{...params}
													onChange={handleSearchOrigin}
													name='origin'
												/>
											)}
										/>
									</div>
									</Box>
								</Grid>
								<Grid item xs={12} md={12} lg={3}>
								<Box
                          style={{
                            border: "1px solid #767b8e",
                            borderRadius: 5,
                            paddingLeft: 13,
                          }}
                        >
									<div className={classes.root}>
										<span style={{ color: 'black',fontSize:20 }}>To</span>
										<Autocomplete
											id='country-select-demo'
											sx={{
												// background: '#eee',
												// borderRadius: 2/,
												padding: '8px',
											}}
											options={buscity && buscity.result.length > 0 ? buscity.result : []}
											autoHighlight
											getOptionLabel={(option) => option.city_name}
											renderOption={(props, option) => (
												<Box style={{width:'100%'}}
													component='li'
													sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
													{...props}>
													<img loading='lazy' width='20' src={bus}  />
													<p style={{marginLeft:5}}>
													{option.city_name} ({option.city_id})
													</p>
												</Box>
											)}
											onChange={(event, value) => {
												setFieldValue('Destination', value.code);
												// setGoing(value.code);
											}}
											renderInput={(params) => (
												<TextField {...params} onChange={handleSearchOrigin} />
											)}
										/>
									</div>
									</Box>
								</Grid>
								<Grid
									item
									xs={12}
									md={12}
									lg={trip == 'oneway' ? 3 : trip == 'roundtrip' ? 6 : 3}>
									{/* <div className={classes.root}> */}
								
									<Box
                          style={{
                            border: "1px solid #767b8e",
                            borderRadius: 5,
							paddingLeft:13
                          }}
                        >
							<span style={{ color: 'black',fontSize:18 }}>Date</span>
							<DesktopDateBus />
						</Box>
									{/* {trip == 'oneway' ? (
										<DesktopDateBus />
									) : trip == 'roundtrip' ? (
										<DateRangeNew />
									) : (
										<DesktopDateBus />
									)} */}
									{/* <DateRangeNew /> */}
									{/* <DesktopDateNew /> */}
									{/* </div> */}
								</Grid>
								{/* <Grid item lg={3}></Grid> */}
								{/* <Grid item xs={12} md={6} lg={6}>
									<ul class='menu' style={{ marginTop: 20, borderRadius: 2 }}>
										<li>
											<a href='#' style={{ padding: 10 }}>
												Travellers,Classes
											</a>

											<ul style={{ width: '100%' }}>
												<li>
													<Box
														style={{ padding: 10 }}
														display='flex'
														justifyContent='space-between'
														textAlign='center'
														alignItems='center'>
														<BodyText four textStyle={{ color: 'white' }}>
															Adult
														</BodyText>
														<Box display='flex' alignItems='center'>
															<Box
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 0 ? '' : setAdult(adult - 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
																	}}>
																	-
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}>
																<BodyText
																	textStyle={{ fontSize: 24, color: 'white' }}>
																	{adult}
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 9 ? '' : setAdult(adult + 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
s																	}}>
																	+
																</BodyText>
															</Box>
														</Box>
													</Box>
												</li>
												<li>
													<Box
														style={{ padding: 10 }}
														display='flex'
														justifyContent='space-between'
														textAlign='center'
														alignItems='center'>
														<BodyText four textStyle={{ color: 'white' }}>
															Child
														</BodyText>
														<Box display='flex' alignItems='center'>
															<Box
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 0 ? '' : setAdult(adult - 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
																	}}>
																	-
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}>
																<BodyText
																	textStyle={{ fontSize: 24, color: 'white' }}>
																	{adult}
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 9 ? '' : setAdult(adult + 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
																	}}>
																	+
																</BodyText>
															</Box>
														</Box>
													</Box>
												</li>
												<li>
													<Box
														style={{ padding: 10 }}
														display='flex'
														justifyContent='space-between'
														textAlign='center'
														alignItems='center'>
														<BodyText four textStyle={{ color: 'white' }}>
															Infant
														</BodyText>
														<Box display='flex' alignItems='center'>
															<Box
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 0 ? '' : setAdult(adult - 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
																	}}>
																	-
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}>
																<BodyText
																	textStyle={{ fontSize: 24, color: 'white' }}>
																	{adult}
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 9 ? '' : setAdult(adult + 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
																	}}>
																	+
																</BodyText>
															</Box>
														</Box>
													</Box>
												</li>
												<li>
													<Box
														style={{ padding: 10 }}
														display='flex'
														justifyContent='space-between'>
														<Box className={classes.radio}>
															<FormControl component='fieldset'>
																<RadioGroup
																	aria-label='gender'
																	name='gender1'
																	value={value}
																	color='white'
																	onChange={handleRadio}>
																	<FormControlLabel
																		value='Economy'
																		control={<Radio />}
																		label='Economy'
																	/>
																	<FormControlLabel
																		value='Business'
																		control={<Radio />}
																		label='Business'
																	/>
																	<FormControlLabel
																		value='First Class'
																		control={<Radio />}
																		label='First Class'
																	/>
																	<FormControlLabel
																		value='Premium Economy'
																		control={<Radio />}
																		label='Premium Economy'
																	/>
																</RadioGroup>
															</FormControl>
														</Box>
													</Box>
												</li>
											</ul>
										</li>
									</ul>
								</Grid> */}
								<Grid item xs={12} md={6} lg={3} >
								<input onClick={handleSubmit}
                          type="submit"
                          value="Search Bus"
                          style={{
                            border: "1px solid #767b8e",
                            borderRadius: 5,
                            paddingLeft: 13,
                            backgroundColor: "#ff4600",
                            padding: 26,
                            textAlign: "center",
                            borderColor: "#ff4600",
                            cursor: "pointer",
                            width: "100%",
                            fontSize:  20 ,
                            color: "white",
                          }}
                        />
								</Grid>
							</Grid>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default SearchBus2;
